import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { toast } from 'react-toastify';

import { REQUEST_USER_DATA } from '../../http/apollo-queries';
import { ConfirmAction } from '../Modal/ConfirmAction';

interface PropTypes {
  closeModal: () => void;
}

const AccountExportModal: React.FC<PropTypes> = ({ closeModal }) => {
  const { t } = useTranslation();

  const [requestUserData] = useLazyQuery(REQUEST_USER_DATA);

  const handleRequestData = async () => {
    const { data } = await requestUserData();

    if (data.requestUserData.status === 'SUCCESS') {
      return true;
    } else {
      closeModal();
      toast.error(t('modals.requestData.error'));
    }
  };

  return (
    <ConfirmAction
      confirmedTitle={t('modals.requestData.confirmedTitle')}
      title={t('modals.requestData.title')}
      subtitle={t('modals.requestData.subtitle')}
      save={handleRequestData}
    />
  );
};

export default AccountExportModal;
